import { RoundsPage } from '@Pages/Rounds/RoundsPage';

export const RoundsRoute: React.FC = () => {
  return <RoundsPage />;
};
